import { useQuery } from '@tanstack/react-query';
import { fetchWithType } from 'utils/api';
import { getAdminUrl, getApiToken } from 'utils/helpers';

export interface SpecItem {
  key: string;
  title: string;
  value: string;
  unit: string | null;
}

export interface SpecGroup {
  category: string;
  label: string;
  items: SpecItem[];
}

export interface CarTrimSpec {
  id: number;
  name: string;
  position: number | null;
  highlights: string[];
  specifications: SpecGroup[];
}

function useSpecs(code?: string) {
  const { data, ...rest } = useQuery({
    queryKey: ['specs', code],
    queryFn: async () => {
      return await fetchWithType<CarTrimSpec[]>(
        getAdminUrl() + '/api/model/' + code + '/specifications',
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${getApiToken()}`,
          },
        },
      );
    },
    enabled: !!code,
  });
  return { specs: data?.data ?? [], ...rest };
}

export default useSpecs;
